import { render, staticRenderFns } from "./Proposal.vue?vue&type=template&id=b45392c2&scoped=true&"
import script from "./Proposal.vue?vue&type=script&lang=js&"
export * from "./Proposal.vue?vue&type=script&lang=js&"
import style0 from "./Proposal.vue?vue&type=style&index=0&lang=less&"
import style1 from "./Proposal.vue?vue&type=style&index=1&id=b45392c2&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b45392c2",
  null
  
)

export default component.exports